import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showConfirmReportIncidentPopup } from '~/actions';
import { Column, Radio, RadioGroup, Typography } from '@tempmee/react';
import { ConfirmPopupContent } from '~/components/shared/ConfirmPopupContent';

import { incidentTypes } from '../utils/incidentPopupUtil';
import { NumberUtils } from '~/utils/NumberUtils';
import { OutlineWarning01Icon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';

export const ConfirmationSelectIncident = ({ onClose }) => {
  const dispatch = useDispatch();
  const [incidentType, setIncidentType] = useState(null);

  return (
    <ConfirmPopupContent
      Icon={() => (
        <OutlineWarning01Icon color={colors.warning[500]} />
      )}
      title="Report An Incident"
      description={
        // gap replaces the radio row's compensating marginTop/Bottom for even rhythm.
        <Column gap={5} data-cy="select-incident-type-content">
          <Typography as="span" textAlign="center" data-cy="incident-prompt-text">
            What type of incident would you like to report?
          </Typography>
          <RadioGroup
            value={incidentType ?? ''}
            onChange={setIncidentType}
            orientation="horizontal"
            data-cy="incident-type-options"
            style={{ justifyContent: 'space-around' }}
          >
            <Radio value={incidentTypes.noShow} label="No-Show" data-cy="incident-type-no-show" />
            <Radio
              value={incidentTypes.walkedOut}
              label="Walked-Out"
              data-cy="incident-type-walked-out"
            />
          </RadioGroup>
          <Typography as="span" textAlign="center" data-cy="incident-support-text">
            If the incident doesn&apos;t fall into these two categories, please call or text our
            Customer Support at {NumberUtils.getCSPhone().formattedSimplified}, and they will be
            able to assist you.
          </Typography>
        </Column>
      }
      leftButtonAction={onClose}
      leftButtonText="Go Back"
      leftButtonDataCy="incident-go-back-button"
      rightButtonAction={() => {
        dispatch(showConfirmReportIncidentPopup({ incidentType }));
      }}
      rightButtonDisabled={!incidentType}
      rightButtonText="Continue"
      rightButtonDataCy="incident-continue-button"
    />
  );
};
